// To swap the sound, replace the file below (or change this import to the new file).
import pointReachedSoundUrl from '../assets/sounds/point-reached.mp3';
const GESTURE_EVENTS = ['pointerdown', 'touchend', 'keydown'];
let audioContext = null;
let pointReachedBuffer = null;
let bufferLoading = null;
const getAudioContextConstructor = () => window.AudioContext ??
    window.webkitAudioContext;
const loadPointReachedBuffer = (context) => {
    if (pointReachedBuffer || bufferLoading) {
        return;
    }
    bufferLoading = fetch(pointReachedSoundUrl)
        .then((response) => response.arrayBuffer())
        // callback form: older Safari doesn't return a promise from decodeAudioData
        .then((data) => new Promise((resolve, reject) => context.decodeAudioData(data, resolve, reject)))
        .then((buffer) => {
        pointReachedBuffer = buffer;
    })
        .catch(() => {
        // retry on the next user gesture
        bufferLoading = null;
    });
};
const unlockAudio = () => {
    try {
        if (!audioContext) {
            const AudioContextClass = getAudioContextConstructor();
            if (!AudioContextClass) {
                return;
            }
            // iOS 17+: mix with other audio and respect the silent switch
            const audioSession = navigator
                .audioSession;
            if (audioSession) {
                audioSession.type = 'ambient';
            }
            audioContext = new AudioContextClass();
        }
        if (audioContext.state !== 'running') {
            audioContext.resume().catch(() => undefined);
        }
        loadPointReachedBuffer(audioContext);
    }
    catch (_) {
        // audio is optional, never break the app
    }
};
/**
 * Browsers only allow audio after a user gesture. Listening permanently (instead of once)
 * also re-activates the audio context after iOS suspends it, e.g. when the app was in the background.
 */
export const registerAudioUnlock = () => {
    GESTURE_EVENTS.forEach((eventName) => document.addEventListener(eventName, unlockAudio, { capture: true, passive: true }));
};
export const playPointReachedSound = () => {
    try {
        if (!audioContext || !pointReachedBuffer) {
            return;
        }
        if (audioContext.state !== 'running') {
            audioContext.resume().catch(() => undefined);
        }
        const source = audioContext.createBufferSource();
        source.buffer = pointReachedBuffer;
        source.connect(audioContext.destination);
        source.start();
    }
    catch (_) {
        // fail silently if playback is blocked or unsupported
    }
};
